import IconWrapper from '@components/ui/Icons';
import { usePdp } from '@context/PdpContext';

import styles from './StoreAvailability.module.scss';
import {
  FEATURE_FLAG_DISABLE_SPU,
  FEATURE_FLAG_NO_PICKUP_TIMES,
} from '@config/feature-flag';
import { useStoreAvailability } from '@utils/store/useStoreAvailability';

const StoreAvailability = ({
  storeId,
  isModal,
  abVariant,
  pickupMessage,
}: {
  storeId: string;
  isModal: boolean;
  abVariant: string | null;
  pickupMessage?: string;
}) => {
  const { selectedAvailability, selectedVariant } = usePdp();

  const result = useStoreAvailability(
    storeId,
    pickupMessage ?? null,
    abVariant,
    isModal
  );

  if (!result) return null;

  const { stockIcon, stockMessage, availabilityMessage } = result;

  if (!stockIcon || !stockMessage) return null;

  return (
    <div className={styles.wrapper}>
      <IconWrapper
        icon={stockIcon}
        width={12}
        classNames={styles.availabilityIcon}
      />
      {/* Changes for d365 cutover:
          Normally, the modal version gets availabilityMessage and stockMessage, but during d365 cutover, we want only
          stockMessage. So, show that in place of availability message and then hide the one in the span.

          Normally, The non-modal version only gets availability message, so we can just replace that with stockMessage.
       */}
      <span className={styles.availabilityText}>
        {FEATURE_FLAG_DISABLE_SPU ? stockMessage : availabilityMessage}{' '}
        {isModal &&
          selectedAvailability &&
          !FEATURE_FLAG_DISABLE_SPU &&
          selectedVariant?.quickPickup &&
          !FEATURE_FLAG_NO_PICKUP_TIMES && (
            <span className={styles.stockMessage}>({stockMessage})</span>
          )}
      </span>
    </div>
  );
};

export default StoreAvailability;
